
import { createModel } from './model'


export default () => {

	const el = document.querySelector('[data-filter]')
	if (!el) return
	const items = [...el.querySelectorAll('[data-filter-item]')]
	const checkboxes = [...el.querySelectorAll('[data-filter-checkbox]')]
	if (!items.length || !checkboxes.length) return

	const clearFiltersButtons = [...el.querySelectorAll('[data-clear-filters]')]
	
	// model
	const model = createModel()	

	// on change

	model.subscribe((key, value, data) => {
		const keys = Object.keys(data)
		const toShow = items.filter(item => {
			const matchedAttrs = keys.map(key => {
				const attr = `data-filter-${key}`
				const valueList = (item.getAttribute(attr)  || '').split(',').map(item => item.trim())
				for (const value of valueList) {
					if (model.listIncludes(key, value)) return true
				}
			}).filter(Boolean)
			if (keys.length === matchedAttrs.length) return true
		})
		items.map(item => item.style.display = 'none')
		toShow.map(item => item.style.display = '')

		if (keys.length) {
			clearFiltersButtons.map(button => button.style.display = '')
		} else {
			clearFiltersButtons.map(button => button.style.display = 'none')
		}
	})

	// event handlers

	checkboxes.map(checkbox => {
		const key = checkbox.getAttribute('data-filter-checkbox-key')
		const value = checkbox.value
		if (!key) return

		checkbox.addEventListener('change', e => {
			e.currentTarget.checked 
				? model.listAdd(key, value) 
				: model.listRemove(key, value)
		})
	})

	clearFiltersButtons.map(button => {
		button.addEventListener('click', () => {
			checkboxes.map(checkbox => {
				checkbox.checked = false
			})
			model.clear()
		})
	})
}